import React from 'react';

import {
  AcademyProjectDetails,
  getAcademyProjectDetails,
  useGetAcademyProjectQuery,
} from 'features/classCreation';
import ErrorLayout from 'components/ErrorLayout';
import Loader from 'components/Loader';
import SectionHeading from 'components/SectionHeading';

function AcademyProjectDetailsModalContent({ academyTopic }) {
  const { academy_project: academyProject } = academyTopic || {};
  const { id: academyProjectId } = academyProject || {};

  const {
    data,
    isLoading,
    error: academyProjectError,
  } = useGetAcademyProjectQuery(academyProjectId, { skip: !academyProjectId });

  const academyProjectDetails = getAcademyProjectDetails(data?.data);

  if (isLoading) {
    return <Loader />;
  } else if (academyProjectError) {
    return (
      <ErrorLayout
        title="Failed to load Case Study"
        message={
          academyProjectError.data?.message ||
          'Something went wrong! Try again later'
        }
      />
    );
  } else if (academyProjectDetails) {
    return (
      <>
        <SectionHeading
          title="CASE STUDY DETAILS"
          className="m-b-s"
        />
        <AcademyProjectDetails academyProjectDetails={academyProjectDetails} />
      </>
    );
  }
}

export default AcademyProjectDetailsModalContent;
